import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLocale, useT } from '../contexts/LocaleProvider';

const TONE = {
  missing: 'badge--bad',
  draft:   'badge--neutral',
  posted:  'badge--info',
  paid:    'badge--ok',
};

/* Where an approved note stands in Odoo · fed by the finance hub's hourly
 * sync (backend: expenses/odoo_status.py). Renders nothing when there is no
 * information: the badge must never imply a state it doesn't know.
 * `link={false}` when the badge already sits inside a link. */
export default function OdooBadge({ odoo, link = true, className = '' }) {
  const t = useT();
  const { intlLocale } = useLocale();
  if (!odoo || !TONE[odoo.state]) return null;
  const date = odoo.paid_on ? new Intl.DateTimeFormat(intlLocale).format(new Date(odoo.paid_on)) : '';
  const label = t(`odoo.${odoo.state}`, { date });
  const cls = `badge ${TONE[odoo.state]} ${className}`.trim();
  if (!link || !odoo.url) return <span className={cls}>{label}</span>;
  return (
    <a
      href={odoo.url}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`${cls} inline-flex items-center gap-1 hover:opacity-80`}
      title={t('odoo.open')}
    >
      {label}
      <ExternalLink className="h-3 w-3" />
    </a>
  );
}
